import { memo } from "react";
import SearchBar from "../SearchBar.jsx";

function HeroSearchBar(props) {
  return <SearchBar {...props} />;
}

export default memo(HeroSearchBar);
